<template>
  <div class="knw_widget_button_wrapper">
    <WidgetButton
      :show-avatar="showAvatarOverlay"
      :avatar-url="getDefaultAvatarUrl"
      @click="onClick"
    ></WidgetButton>
    <!-- <div class="knw_widget_button">
      <transition name="buttonfade" mode="out-in">
        <IconChatBubble />
      </transition>
      <transition name="kw-avatar-transition">
        <transition name="kw-avatar-wrapper" appear>
          <div v-if="showAvatarOverlay" class="avatar-wrapper">
            <Avatar :image="getDefaultAvatarUrl" width="64px" height="64px" shadow />
          </div>
        </transition>
      </transition>
    </div> -->
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useLayoutStore } from "@/store/layout";
import { useWidgetStore } from "@/store/widget";
import { useI18n } from "@/composables/useI18n.js";
import { useMoinBot } from "@/services/bot/botv2";
import { useIframeManager } from "@/composables/useIframeManager";
import { useTeaserStore } from "@/store/teaser";
import WidgetButton from "./WidgetButton.vue";

const props = defineProps<{
  frame: HTMLIFrameElement;
}>();
const widgetStore = useWidgetStore();
const teaserStore = useTeaserStore();
const { getDefaultAvatarUrl } = useMoinBot();

const { isWidgetOpen, isVisible } = storeToRefs(widgetStore);
const layoutStore = useLayoutStore();
const {
  buttonOffset: offsetOverwrites,
  isMobileTeaser,
  alignmentOrigin,
  zIndex,
} = storeToRefs(layoutStore);

const { t } = useI18n();

// isVisible will never be true because we unmount everything in app.vue
// we still leave this here for future reference and completeness
const isElementVisible = computed(() => !isWidgetOpen.value && isVisible.value);

// ##############################
// Button defaults:
// 5px from top and 5px from left on mobile
// 25px from top and 25px from left on desktop

const xOffset = computed(() => {
  // defaults
  let value = isMobileTeaser.value ? "5px" : "25px";
  // overwrites via config / api if available
  if (offsetOverwrites.value?.x) {
    value = offsetOverwrites.value.x;
  }
  // on we omit position changes on the x axis and only allow changes on the y axis
  return isMobileTeaser.value ? "5px" : value;
});

const yOffset = computed(() => {
  // default behavior for mobile teaser and desktop teaser
  let value = isMobileTeaser.value ? "5px" : "25px";
  // if we have a value for the y axis set via api or config, we use that instead
  if (offsetOverwrites.value?.y) {
    value = offsetOverwrites.value.y;
  }
  // but we ignore sone axis on mobile
  return value;
});

const buttonLayout = computed(() => {
  return {
    name: "button",
    isElementVisible: isElementVisible.value,
    width: "85px!important",
    height: "85px!important",
    // on we omit position changes on the x axis and only allow changes on the y axis
    x: xOffset.value,
    y: yOffset.value,
    xAlignment: alignmentOrigin.value.x,
    yAlignment: alignmentOrigin.value.y,
    zIndex: zIndex.value,
  };
});

const attrs = computed(() => {
  return {
    "aria-hidden": !isElementVisible.value,
    title: t("iframe.button.title"),
    name: "moin-ai-button",
  };
});

useIframeManager(props.frame, buttonLayout, undefined, attrs);
const showAvatarOverlay = computed(() => teaserStore.showAvatar);
const onClick = () => widgetStore.openWidget();
</script>

<style lang="scss" scoped>
/* .buttonfade-enter-active,
.buttonfade-leave-active {
  transition: opacity 0.25s;
  transform: translateY(-400px);
}

.buttonfade-enter-from,
.buttonfade-leave-to

  {
  opacity: 0;
  transform: translateY(-400px);
} */

/* AVATAR WRAPPER TRANSITION */
/* .kw-avatar-wrapper-transition-enter-from {
  border-width: 0;
  border-radius: 50%;
}

.kw-avatar-wrapper-transition-enter-active {
  transition: border-width 0.25s linear;
}

.kw-avatar-wrapper-transition-enter-to {
  border-width: 3px;
  border-radius: 50%;
} */

@media print {
  #moinai-container {
    display: none;
  }
}
</style>
